'use client';

export function ContactPhoneIcon() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-label='Contact Phone'
    >
      <path
        d='M9.16667 7.5H10.8333V9.16667H9.16667V7.5ZM12.5 7.5H14.1667V9.16667H12.5V7.5ZM16.6667 12.9167C15.625 12.9167 14.625 12.75 13.6917 12.4417C13.6083 12.4167 13.5167 12.4 13.4333 12.4C13.2167 12.4 13.0083 12.4833 12.8417 12.6417L11.0083 14.475C8.65 13.275 6.71667 11.35 5.51667 8.99167L7.35 7.15C7.58333 6.925 7.65 6.6 7.55833 6.30833C7.25 5.375 7.08333 4.375 7.08333 3.33333C7.08333 2.875 6.70833 2.5 6.25 2.5H3.33333C2.875 2.5 2.5 2.875 2.5 3.33333C2.5 11.1583 8.84167 17.5 16.6667 17.5C17.125 17.5 17.5 17.125 17.5 16.6667V13.75C17.5 13.2917 17.125 12.9167 16.6667 12.9167ZM4.19167 4.16667H5.44167C5.5 4.9 5.625 5.625 5.825 6.325L4.825 7.33333C4.48333 6.325 4.26667 5.26667 4.19167 4.16667ZM15.8333 15.8083C14.7333 15.7333 13.6667 15.5167 12.6667 15.175L13.6667 14.175C14.375 14.375 15.1 14.5 15.8333 14.55V15.8083ZM15.8333 7.5H17.5V9.16667H15.8333V7.5Z'
        fill='#0063E8'
      />
    </svg>
  );
}
